import * as React from 'react';

import { Layout } from '../../../ServicePickerWidget/Layout';

import { usePublicationLayoutShowAnalytics } from './hooks';

interface IPublicationLayoutProps {
  content: React.ReactNode;
  title: React.ReactNode;
}

export const PublicationLayout = ({ title, content }: IPublicationLayoutProps) => {
  usePublicationLayoutShowAnalytics();

  return (
    <Layout>
      <Layout.Title>{title}</Layout.Title>
      <Layout.Content>{content}</Layout.Content>
    </Layout>
  );
};
